import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Clock, Tag } from 'lucide-react';
import { CompletionConfetti } from './CompletionConfetti';
export interface Task {
  id: string;
  title: string;
  category: string;
  duration: string;
  completed: boolean;
}
interface TaskItemProps {
  task: Task;
  onToggle: (id: string) => void;
}
export function TaskItem({
  task,
  onToggle
}: TaskItemProps) {
  const [showConfetti, setShowConfetti] = useState(false);
  const handleToggle = () => {
    if (!task.completed) {
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 1000);
    }
    onToggle(task.id);
  };
  return <motion.div layout initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    scale: 0.9
  }} whileHover={{
    scale: 1.02
  }} className={`
        relative group mb-3 p-4 rounded-3xl border-2 transition-all duration-300
        ${task.completed ? 'bg-gray-50 border-gray-100 opacity-75' : 'bg-white border-transparent shadow-bubbly hover:border-game-purple/20'}
      `} data-id="element-521">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-522">
        <CompletionConfetti trigger={showConfetti} data-id="element-523" />
      </div>

      <div className="flex items-center gap-4" data-id="element-524">
        <motion.button whileTap={{
        scale: 0.8
      }} onClick={handleToggle} className={`
            flex-shrink-0 w-8 h-8 rounded-full border-2 flex items-center justify-center
            transition-colors duration-300
            ${task.completed ? 'bg-game-teal border-game-teal' : 'bg-white border-gray-200 group-hover:border-game-purple'}
          `} data-id="element-525">
          {task.completed && <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} data-id="element-526">
              <Check className="w-5 h-5 text-white stroke-[3]" data-id="element-527" />
            </motion.div>}
        </motion.button>

        <div className="flex-1 min-w-0" data-id="element-528">
          <h3 className={`
            font-quicksand font-bold text-lg truncate transition-all duration-300
            ${task.completed ? 'text-gray-400 line-through' : 'text-game-dark'}
          `} data-id="element-529">
            {task.title}
          </h3>

          <div className="flex items-center gap-3 mt-1" data-id="element-530">
            <div className={`
              flex items-center gap-1 text-xs font-bold px-2 py-0.5 rounded-full
              ${task.completed ? 'bg-gray-100 text-gray-400' : 'bg-game-bg-purple text-game-purple'}
            `} data-id="element-531">
              <Tag className="w-3 h-3" data-id="element-532" />
              {task.category}
            </div>
            <div className={`
              flex items-center gap-1 text-xs font-bold
              ${task.completed ? 'text-gray-400' : 'text-gray-400'}
            `} data-id="element-533">
              <Clock className="w-3 h-3" data-id="element-534" />
              {task.duration}
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}